module.exports = __webpack_public_path__ + "static/media/feed-fill.ea1282d1.svg";